import React, { useEffect } from "react"
import IPWhitelistComponent from "components/Global/IPWhiteList"
import { useDispatch } from "react-redux";
import { GetIpWhteList } from 'redux/action/ipWhiteListAction';
const IpWhitelisting = () => {
    const dispatch = useDispatch();

    // Use the `useEffect` hook to clear Redux state when the component mounts.
    useEffect(() => {
        // Dispatch the action to clear Redux state for the RoleTable slice.
        dispatch(GetIpWhteList());
    }, []);
    return <><IPWhitelistComponent /></>
}
export default IpWhitelisting